import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds", "expired"];
  static values = { expiresAt: String };

  connect() {
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    clearInterval(this.interval);
  }

  tick() {
    const end = new Date(this.expiresAtValue);
    const diff = end - Date.now();

    if (diff <= 0) {
      this.showExpired();
      return;
    }

    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    if (this.hasDaysTarget) this.daysTarget.textContent = String(d).padStart(2, "0");
    if (this.hasHoursTarget) this.hoursTarget.textContent = String(h).padStart(2, "0");
    if (this.hasMinutesTarget) this.minutesTarget.textContent = String(m).padStart(2, "0");
    if (this.hasSecondsTarget) this.secondsTarget.textContent = String(s).padStart(2, "0");
  }

  showExpired() {
    clearInterval(this.interval);
    this.element.classList.add("opacity-60");
    if (this.hasExpiredTarget) this.expiredTarget.classList.remove("hidden");
  }
}
